import React, {Component} from 'react';
import {connect} from 'react-redux';
import {fromJS} from 'immutable';
import QueryString from 'query-string';
import SweetAlert from 'sweetalert-react';
import withSizes from 'react-sizes';

import * as Utils from '../../utils/utils';
import * as HtmlHelper from '../../utils/htmlHelper';
import * as ProductsActions from '../../actions/productsActions';
import ProductCard from '../../components/commons/cards/ProductCard';
import CollapsableItem from '../../components/commons/collapsable-item/CollapsableItem';
import Loader from '../../components/commons/loader/loader';
import SortFiltersModal from '../../components/commons/modals/SortFiltersModal';

class ProductListPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      products: [],
      isDescriptionPanelCollapsed: false,
      isSizePanelCollapsed: false,
      isLocationPanelCollapsed: false,
      limit: 20,
      skip: 0,
      isLoadMore: false,
      isParamsChanged: true,
      filters: DEFAULT_FILTERS,
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_location: []
      },
      selectedFilters: [],
      SortFiltersModalVisibility: false,
      filterSortAction: 'filter',
      showAlert: false,
      swalParams: {
        title: ""
      },
      scrollTop:0
    }

    this.renderDescriptions = this.renderDescriptions.bind(this);
    this.renderSizes = this.renderSizes.bind(this);
    this.renderLocations = this.renderLocations.bind(this);
    this.loadProducts = this.loadProducts.bind(this);
    this.exploreProduct = this.exploreProduct.bind(this);
    this.renderLoadMoreButton = this.renderLoadMoreButton.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.selectFilter = this.selectFilter.bind(this);
    this.renderSelectedFilters = this.renderSelectedFilters.bind(this);
    this.selectedFilterUnselect = this.selectedFilterUnselect.bind(this);
  }

  componentDidMount() {

    const {location} = this.props;
    const pageState = Utils.toJS(this.props.pageState);
    let params = QueryString.parse(location.search);

    if(pageState && pageState.location && pageState.location.search == location.search) {
      this.setState(pageState, () => window.scrollTo(0, pageState.scrollTop));
    } else {
      this.loadProducts(params);
      this.loadFilters(params);
      window.scrollTo(0, 0);
    }

  }

  componentWillReceiveProps(newProps) {

    const {location} = this.props;
    let params = QueryString.parse(newProps.location.search);
    if (location.search !== newProps.location.search) {
      this.setState({
        isParamsChanged: true,
        selectedFilters: [],
        appliedFilters: {
          filterby_sizes: [],
          filterby_description: [],
          filterby_location:[]
        }
      }, () => {
        this.loadProducts(params)
        this.loadFilters(params)
      })
    } else
      this.setState({isParamsChanged: false})

  }

  render() {
    console.log('NEW_ARRIVALS_LIST_PAGE_PROPS', this.props);
    console.log('NEW_ARRIVALS_LIST_PAGE_STATES', this.state);

    const {products, showAlert, swalParams} = this.state;
    const {isMobile, loading} = this.props;

    const {
      isDescriptionPanelCollapsed,
      isSizePanelCollapsed,
      isLocationPanelCollapsed,
      location,
      SortFiltersModalVisibility,
      filterSortAction,
      filters,
      appliedFilters,
      scrollTop
    } = this.state;

    return (
      <div className="page product-list">
        <div className="container content-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 sidebar">
              {this.renderSelectedFilters()}
              <CollapsableItem title="Type" isCollapsed={isDescriptionPanelCollapsed} renderBody={this.renderDescriptions} onToggleBody={() => this.setState({
                isDescriptionPanelCollapsed: !isDescriptionPanelCollapsed
              })}/>
              <CollapsableItem title="Location" isCollapsed={isLocationPanelCollapsed} renderBody={this.renderLocations} onToggleBody={() => this.setState({
                isLocationPanelCollapsed: !isLocationPanelCollapsed
              })}/>
              <CollapsableItem title="Size" isCollapsed={isSizePanelCollapsed} renderBody={this.renderSizes} onToggleBody={() => this.setState({
                isSizePanelCollapsed: !isSizePanelCollapsed
              })}/>

            </div>
            <div className="col-md-8 col-lg-9">
              <div className="row">
                <div className="col-md-8 left-container">
                  <h1 className="page-title">{'Best Sellers'}</h1>
                  <div className="page-description">{`We found ${products.length} results`}</div>
                </div>
                <div className="col-md-4 right-container"></div>
              </div>

              {isMobile ? (
                <div className="row product-cards-row-mobile">
                  {products && Utils.chunkArrayInGroups(products, 2).map((productsInRow, idx) => {
                    return (
                      <div className="product-cards-mobile" key={`products_row_${idx}`}>
                        <div className="product-card-container">
                          <ProductCard data={productsInRow[0]} onSelectProduct={() => this.exploreProduct(productsInRow[0])} onAddToCart={() => this.addToCart(productsInRow[0])} noOutOfStock={true}/>
                        </div>
                        {productsInRow.length == 2 ? (
                          <div className="product-card-container">
                            <ProductCard data={productsInRow[1]} onSelectProduct={() => this.exploreProduct(productsInRow[1])} onAddToCart={() => this.addToCart(productsInRow[1])} noOutOfStock={true}/>
                          </div>
                        ) : null}
                      </div>
                    )
                  })}
                </div>
              ) : (
                <div className="row product-cards">
                  {products && products.map((product, idx) => {
                    return (
                      <div className="col-md-6 col-lg-4 product-card-container" key={`product_${idx}`}>
                        <ProductCard data={product} onSelectProduct={() => this.exploreProduct(product)} onAddToCart={() => this.addToCart(product)} noOutOfStock={true}/>
                      </div>
                    )
                  })}
                </div>
              )}

              {this.renderLoadMoreButton()}
            </div>

          </div>
        </div>
        <div className="mobile-filter-sort-bar">
          <div className="filters-button button-block" onClick={() => {
            HtmlHelper.hideBodyScroll((scrollTop) => {
              this.setState({SortFiltersModalVisibility: true, filterSortAction: 'filter', scrollTop: scrollTop});
            })
          }}>Filters</div>
        </div>
        <Loader visibility={loading}/>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
        <SortFiltersModal visibility={SortFiltersModalVisibility} actionMode={filterSortAction} filters={filters} appliedFilters={appliedFilters} onApply={(filters, sort) => {
          this.setState({
            SortFiltersModalVisibility: false
          }, () => {
            this.onApplySortAndFilters(filters, sort);
            HtmlHelper.showBodyScroll(0);
          })
        }} onClose={() => {
          HtmlHelper.showBodyScroll(scrollTop);
          this.setState({SortFiltersModalVisibility: false});
        }}
        onClearFilters={() => {
          HtmlHelper.showBodyScroll(0);
          this.setState({SortFiltersModalVisibility: false}, () => this.clearFilters());
        }}
        hideSortOptions={true}/>
      </div>
    )
  }

  renderDeliveryAddress() {
    return (
      <div className="filter-item-text">
        <ul>
          <li>828 s. Main Street,</li>
          <li>Los Angeles, CA 90014</li>
        </ul>
      </div>
    );
  }

  renderSizes() {

    const {filters, appliedFilters} = this.state;
    let filterCount = filters && filters.filterby_sizes
      ? filters.filterby_sizes.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_sizes.items.map((filter, idx) => {
                let isSelected = appliedFilters.filterby_sizes.indexOf(filter._id) != -1
                console.log("IS SELECTED", filter._id, appliedFilters.filterby_sizes.indexOf(filter._id));
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_sizes_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_sizes', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
}
      </div>
    )
  }

  renderDescriptions() {

    const {filters, appliedFilters} = this.state;
    let filterCount = filters && filters.filterby_description
      ? filters.filterby_description.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_description.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_description.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_description_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_description', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
}
      </div>
    )
  }

  renderLocations() {

    const {filters, appliedFilters} = this.state;
    let filterCount = filters && filters.filterby_location
      ? filters.filterby_location.items.length
      : 0;

    return (
      <div className="filter-item-text custom-scrollbar">
        {filterCount > 0
          ? (
            <ul>
              {filters.filterby_location.items.map((filter, idx) => {

                let isSelected = appliedFilters.filterby_location.indexOf(filter._id) != -1;
                return filter._id && filter._id.trim() ? (
                  <li key={`filterby_location_${filter._id}`} className={`option ${isSelected
                    ? 'active'
                    : ''}`} onClick={() => this.selectFilter('filterby_location', filter)}>{`${filter._id} (${filter.count})`}</li>
                ) : null
              })}
            </ul>
          )
          : null
}
      </div>
    )
  }

  renderSelectedFilters() {
    const {selectedFilters} = this.state;
    console.log(selectedFilters);

    return selectedFilters.length
        ? (<div className="selected-filters">
        <h4>You've selected filters</h4>
          {
            _.map(selectedFilters,(filter) => {
              return(<div className="filter--item" key={filter._id}>
                {filter._id}
                <button onClick={()=>this.selectedFilterUnselect(filter)}>x</button>
              </div>
            );
            })
          }
          <a className="clear-filters-link" href="javascript:void(0)" onClick={() => this.clearFilters()}>Clear all Filters</a>
        </div>)
        : (null);
  }

  selectedFilterUnselect(filter){
    console.log(filter);

    this.selectFilter(filter.type,filter);
    //
    // if(filter.type == 'size'){
    //   this.selectFilter('filterby_sizes', filter)
    // }else{
    //   this.selectFilter('filterby_description', filter)
    // }
  }

  selectFilter(type, filter) {

    const {products, skip, sortBy} = this.state;
    let modifiedFilters = this.state.appliedFilters;
    let selectedFilters = this.state.selectedFilters;
    console.log(filter);
    let modifiedFilter = Object.assign({},filter);
    modifiedFilter['type'] = type;
    let indexOfFilter = selectedFilters.findIndex(x=> x._id == filter._id);
    console.log("Selected FIlter Index",indexOfFilter);

    if(indexOfFilter < 0){
      selectedFilters.push(modifiedFilter);
    }else{
      selectedFilters.splice(indexOfFilter,1);
    }


    if (!modifiedFilters[type])
      modifiedFilters[type] = [];
    if (modifiedFilters[type].indexOf(filter._id) < 0){
      modifiedFilters[type].push(filter._id);
    }
    else{
      modifiedFilters[type].splice(modifiedFilters[type].indexOf(filter._id), 1);
    }
    this.setState({selectedFilters})
    this.onApplySortAndFilters(modifiedFilters, sortBy);
  }

  onApplySortAndFilters(filters, sortBy) {

    const {products, skip} = this.state;
    let isFilters = (filters.filterby_sizes.length > 0) || (filters.filterby_description.length > 0) || (filters.filterby_location.length > 0);
    this.setState({
      appliedFilters: filters,
      sortBy: sortBy,
      products: isFilters
        ? []
        : products,
      skip: isFilters
        ? 0
        : skip
    }, () => {
      this.loadProducts();
    });
  }

  clearFilters() {

    const {sortBy} = this.state;
    this.setState({
      appliedFilters: {
        filterby_sizes: [],
        filterby_description: [],
        filterby_location: []
      },
      selectedFilters: [],
      sortBy: sortBy,
      products: [],
      skip: 0
    }, () => {
      this.loadProducts();
    });
  }

  renderLoadMoreButton() {

    const {isLoadMore} = this.state;

    return isLoadMore
      ? (
        <div className="load-more-button" onClick={() => this.loadMore()}>Load More</div>
      )
      : null;
  }

  loadProducts(params, options) {

    const {location} = this.props;
    const {limit, products, isParamsChanged, appliedFilters} = this.state;
    params = params
      ? params
      : QueryString.parse(location.search);
    let skip = options && options.skip
      ? options.skip
      : this.state.skip;
    if (isParamsChanged)
      skip = 0;

    params.limit = limit;
    params.skip = skip;
    params.filters = appliedFilters;
    this.props.dispatch(ProductsActions.getNewArrivalProducts(params, response => {
      console.log("NEW_ARRIVALS_GET_RESPONSE", response);
      if (response.status) {
        this.setState({
          products: isParamsChanged
            ? response.data
            : products.concat(response.data),
          skip: skip,
          isLoadMore: response.data && (response.data.length == limit)
        });
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Something went wrong, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }

    }));
  }

  loadMore() {

    const {limit} = this.state;
    const {location} = this.props;
    let params = QueryString.parse(location.search);
    let skip = this.state.skip + limit;
    this.loadProducts(params, {skip});
  }

  loadFilters(params) {

    this.props.dispatch(ProductsActions.getProductFilters({
      type: 'department',
      name:'BEST_SELLERS'
    }, response => {
      console.log("FILTERS_GET_RESPONSE", response);
      if (response.status) {
        this.setState({filters: response.data})
      } else {
        this.setState({
          showAlert: true,
          swalParams: {
            title: "Something went wrong, please try again later!",
            type: "error",
            showConfirmButton: false
          }
        })
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }

    }))
  }

  exploreProduct(product) {

    const {location} = this.props;
    console.log("PRODUCT_SELECTED_ID: ", product._id);

    let state = this.state;
    state.location = location;
    state.scrollTop = window.pageYOffset;
    this.props.dispatch(ProductsActions.setListPageState(fromJS(state)));
    this.props.history.push(`/products/${product._id}`);
  }

  addToCart(product) {
    Utils.addToCart(product)
      .then(() => {
        this.setState({
          isItemAddedToCart: true,
          showAlert: true,
          swalParams: {
            title: "Product added to cart successfully.",
            type: "success",
            showConfirmButton: false,
          }
        })
        setTimeout(() => this.setState({ showAlert: false }), 1500);
      })
      .catch(err => {
        console.error(err);
        this.setState({
          showAlert: true,
          swalParams: {
            title: err.title,
            type: "warning",
            showCloseButton: true
          }
        });
      });
  }

}

const DEFAULT_FILTERS = {
  filterby_sizes: {
    id: 'filterby_sizes',
    name: 'Sizes',
    index: 'Size',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_description: {
    id: 'filterby_description',
    name: 'Descriptions',
    index: 'Sub Description 2',
    itemType: 'checkbox',
    items: [],
    products: {}
  },
  filterby_location: {
    id: 'filterby_location',
    name: 'Locations',
    index: 'Sub Description 3',
    itemType: 'checkbox',
    items: [],
    products: {}
  }
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 768,
    isTablet: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    pageState: state.getIn(['products', 'listPageState']),
    loading: state.getIn(['products', 'loading']),
    products: state.getIn(['products', 'products'])
  };
})(ProductListPage))



// WEBPACK FOOTER //
// ./src/containers/products/BestSellersListPage.js